import React,{ useState } from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input,Row, Col,
    ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import avatar from '../../assets/images/users/3.jpg'
import Select, {components} from 'react-select'
import countryList from 'react-select-country-list'
// import { SelectTimezone } from 'react-select-timezone';
import TimeZoneField from '../../components/people/timeZoneField'
import GoogleMapReact from 'google-map-react';
import ImageUploader from 'react-images-upload';
import { baseURL,baseImgURL } from '../../Api/BaseApi';
import { auth } from '../../Api'
// import { registerSupervisor } from '../../Api/ChildrenApi';
import { getName } from 'country-list';
import 'react-phone-number-input/style.css'
import PhoneList from '../../components/people/phoneList'
import GuardDutySwitch from '../../components/people/guardDutySwitch'
import { dialCodeFor, phoneListRequest } from '../../utils/phone'
import ct from 'countries-and-timezones'
import { MAX_FIELD_LENGTH, isFieldTooLong } from '../../utils/fieldLimits'
import { formatServerMessage } from '../../utils/serverErrors'
import { personName, isSharedPhoneReply, sharedPhoneState, confirmedSharedPhoneRequest, isValidCid, digitsOnly, CID_MESSAGE } from '../../utils/people'
import SharedPhoneModal from '../../components/people/sharedPhoneModal'
import { leaveForm } from '../../utils/formReturn'
import BackToGuard from '../../components/people/backToGuard'
import { isDistrictManager, ownDistrictPicks } from '../../utils/adminLevel'

const TreeTable = treeTableHOC(ReactTable);


export function CountryFlag(props) {
    return (
      <span
        className={"flag-icon flag-icon-" + props.code}
        style={{ fontSize: props.size || "30px" }}
      />
    );
  }
  
  export const CountryFlagSelectOption = props => {
    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <CountryFlag size={props.flagSize} code={props.value.toLowerCase()} />
          {props.label}
        </div>
      </components.Option>
    );
  };
  
  export const CountryFlagValueContainer = ({ children, ...props }) => {
    const code = (props.hasValue && props.getValue()[0].value) || false;
  
    return (
      <div style={{ display: "flex", flexGrow: 1 }}>
        {(code && <CountryFlag code={code.toLowerCase()} />) || null}
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      </div>
    );
  };
  
  const styles = {
    valueContainer: (base, state) => {
      const height = "35px";
      return { ...base, height };
    }
  };

class CompanyView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked:false,
			open: false,
			modal: false,
			obj: {},
			jsonData: data.dataTable,
			data: data.makeData(),
			treedata: data.treedata,
			options: countryList().getData(),
			firstName: '',
			secondName:'',
			CID:'',
			phoneValue:'',
			otherPhones: [],
			timeValue: '',
			countryValue:null,
			emailValue: 'com@com.com',
			avatarUrl:'/storage/avatar.jpg',
			center: {
				lat: 59.95,
				lng: 30.33
			},
			zoom: 11,
			districtLst:[],
			districtOption: null,
			managerLst:[],
			managerOption: null,
			clientLst: [],
			clientOption: null,
			showAlert:false,
			showResult:false,
			pictures: [],
			guardId:"null",
			defaultCountry: null,
			selectedCountry: null,
			sharedPhone: null,
			// On duty / Off duty (an existing guard only; the history is on the Guard Information page)
			onDuty: 1
		};
		this.toggle = this.toggle.bind(this);
		this.onDrop = this.onDrop.bind(this);
	}
	
	toggle() {
		this.setState({
		  showAlert: !this.state.showAlert
		});
	  }

	componentDidMount(){
		const {id} = this.props.match.params
		let companyId = localStorage.getItem('companyId')
		let {districtLst} = this.state
		this.setState({
			guardId:id,
			company_id:companyId
		})
		auth.getCompany({ id: companyId })
			.then((res) => {
				if (res.data.code == 200) {
					let companyData = res.data.message.users[0];
					this.setState({ defaultCountry: companyData.countrycode, dialCode: dialCodeFor(companyData.countrycode) });
					if (id == "null") {
						this.setState({
							timeValue: { value: companyData.timezone, label: companyData.timezone },
							selectedCountry: companyData.countrycode
						});
					}
				}
			});
		var req={}
		req.company_id = companyId
		auth.getDistrict(req)
			.then((res)=>{
				districtLst=[]
				if(res.data.code==200){
					res.data.message.users.forEach(element => {
					districtLst.push({value:element.id.toString(),label:element.name})
					});
				this.setState({districtLst})
				// A district manager: their district and themselves
				const own = ownDistrictPicks()
				if (own && !this.state.districtOption) {
					this.setState(own)
				}
				}
			})
		if(id!="null"){
			req={}
			req.id = id
			req.company_id = localStorage.getItem('companyId')
			auth.getGuard(req)
				.then((res)=>{
					let guardData = res.data.message.users[0]
					this.setState({
						firstName:guardData.firstname,
						secondName:guardData.secondname,
						// The saved name, for "Back to ..." (not the one being typed)
						guardName: personName(guardData, 'guard'),
						CID:guardData.CID,
						phoneValue:guardData.phone,
						// The person's other numbers (the first is "phone")
						otherPhones: (guardData.phones || []).slice(1),
						districtOption:{value:guardData.district_id,label:guardData.district_name},
						managerOption:{value:guardData.districtmanager_id,label:guardData.districtmanager_name},
						avatarUrl:guardData.avatar,
						timeValue:{value:guardData.timezone,label:guardData.timezone},
						selectedCountry:guardData.countrycode,
						onDuty: guardData.on_duty
					})
				})
		}
	}

	districtChange=(e)=>{
		let { managerLst} = this.state
		this.setState({
			districtOption:e,
		})
		var district_id = e.value
		var req={}
		req.district_id=district_id

		auth.getDistrictManager(req)
			.then((res)=>{
				managerLst=[]
				if(res.data.code==200){
					res.data.message.users.forEach(element => {
						managerLst.push({value:element.id,label:personName(element, 'manager')})
					})
				}
				this.setState({managerLst})
			})
	  }
	managerChange=(e)=>{
		this.setState({
			managerOption:e,
		})
		console.log("e.managerID:",e)
	}

	setPhoneNumber = (event) => {
		console.log("event of phone:", event)
		this.setState({
			phoneValue: event
		})
	}
	changeTimezone = value => {
		console.log("timezone:", value)
		this.setState({ timeValue: value });
	}

    handleChange = (event)=>{
		console.log(["event.valu:",event.target.value, event.target.name])
		switch(event.target.name){
		  	case "firstName":
				this.setState({
				firstName:event.target.value
				})
				break;
			case "secondName":
				this.setState({
				secondName:event.target.value
				})
				break;
			case "CID":
				this.setState({
				CID:digitsOnly(event.target.value)
				})
				break;
			case "phone":
				this.setState({
				phoneValue:event.target.value
				})
				break;
		}
	  }
	onSave = (event) =>{
		let {emailValue,phoneValue,countryValue,firstName,secondName,CID,
			password,avatarUrl,company_id,timeValue,
		districtOption,managerOption,clientOption,guardId
		} = this.state
		this.setState({showResult:false});
		var req={}
		req.firstname = firstName
		req.secondname = secondName
		req.CID = CID
		// The local number completed with the company's dialling code (null when it is not usable)
		// Every number, each completed with the company's dialling code; the first is the main one
		const phoneList = phoneListRequest([phoneValue].concat(this.state.otherPhones), this.state.dialCode)
		req.phone = phoneList.phone
		req.phones = phoneList.phones
		req.email = emailValue
		req.timezone = timeValue.value
		req.company_id = company_id
		req.avatar = avatarUrl
		req.countrycode = this.state.selectedCountry || this.state.defaultCountry;
		if(districtOption!=null)
		  {
			req.district = districtOption.label  
			req.district_id = districtOption.value
		}else{
			req.district_id = -1;
		}
		
		if(managerOption!=null){
			req.districtmanager_id = managerOption.value
		}else{
			req.districtmanager_id = -1;
		}
		if(clientOption!=null){
			req.client_id = clientOption.value
		}else{
			req.client_id = -1;
		}
		var that = this;
		let alertMessage = "";
		if(!req.firstname || req.firstname.trim() === ''){
		  alertMessage='Please enter a First name.'
		  that.setState({
			showAlert:true,
			showResult:false,
			alertMessage:alertMessage
		  })
		}
		else if(isFieldTooLong(req.firstname)){
		  alertMessage='First name must be '+MAX_FIELD_LENGTH+' characters or fewer.'
		  that.setState({
			showAlert:true,
			showResult:false,
			alertMessage:alertMessage
		  })
		}
		else if(!req.secondname || req.secondname.trim() === ''){
			alertMessage='Please enter a Last name.'
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage:alertMessage
			})
		  }
		else if(isFieldTooLong(req.secondname)){
			alertMessage='Last name must be '+MAX_FIELD_LENGTH+' characters or fewer.'
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage:alertMessage
			})
		  }
		else if(!req.CID || req.CID.trim() === ''){
			alertMessage='Please enter a CID.'
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage:alertMessage
			})
		  }
		else if(!isValidCid(req.CID)){
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage:CID_MESSAGE
			})
		  }
		else if(req.phone === null){
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage: phoneList.problem
			})
		  }
		else if(districtOption==null){
		  alertMessage='Please select District'
		  that.setState({
			showAlert:true,
			showResult:false,
			alertMessage:alertMessage
		  })
		}
		else if(managerOption==null){
			alertMessage='Please select District Manager'
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage:alertMessage
			})
		  }
		else if(!req.timezone || !req.countrycode){
			alertMessage='Please wait for the page to finish loading, then try saving again.'
			that.setState({
			  showAlert:true,
			  showResult:false,
			  alertMessage:alertMessage
			})
		  }
		else
		{
			if(guardId!="null"){
				req.id = guardId
			}
			this.send(req)
		}
		event.preventDefault();
	  }

	// Saves the guard. A phone number someone else in the company also has is asked about first
	// (code 409); Yes sends it again with confirm_shared_phone.
	send = (req) => {
		const isUpdate = this.state.guardId != "null"
		const save = isUpdate ? auth.updateGuard : auth.registerGuard
		save(req)
			.then((res)=>{
				if(isSharedPhoneReply(res)){
					this.setState({ sharedPhone: sharedPhoneState(res, req, 'guard') })
				}
				else if(res.data.code==201){
					// Back to the page the form was opened from, or the guard's page
					const id = isUpdate ? this.state.guardId : res.data.message && res.data.message.id
					leaveForm(this.props.history, id ? '/guard-info/' + id : '/guards')
				}
				else {
					// e.g. "The CID 1234 is already used by Jo Bloggs (guard)"
					this.setState({
						showAlert:true,
						showResult:false,
						alertMessage:formatServerMessage(res.data.message, 'The guard could not be saved.')
					})
				}
			})
	}

	// samePerson: the person of another kind the admin said this is (Yes), or null (No, or Continue)
	confirmSharedPhone = (samePerson) => {
		const { req } = this.state.sharedPhone
		// Saved with that person's CID: the form shows it
		this.setState(samePerson ? { sharedPhone: null, CID: samePerson.cid } : { sharedPhone: null })
		this.send(confirmedSharedPhoneRequest(req, samePerson))
	}

	onDrop(picture) {
		var file = picture[0]
		var that = this;
		var objectUrl = URL.createObjectURL(file);
		var img = new window.Image();
		img.onload = function() {
			URL.revokeObjectURL(objectUrl);
			if (img.width > 360 || img.height > 360) {
				that.setState({
					showAlert: true,
					showResult: false,
					alertMessage: 'Image must be at most 360x360 pixels (' + img.width + 'x' + img.height + ' selected).'
				})
				return;
			}
			var req = {}
			req.file = file
			auth.upload(req)
			  .then((res)=>{
				if(res.data.code==201){
					var avatarL = res.data.url.split("/")
					that.setState({
					  avatarUrl: avatarL[avatarL.length-1]
					})
				}
			  })
			that.setState({
				pictures: that.state.pictures.concat(picture),
			});
		}
		img.src = objectUrl;
	}

		render() {
			const { avatarUrl, districtOption, districtLst, managerLst, managerOption,
				clientLst,guardId } = this.state;
        
        const items = [
			{
			  id: 0,
			  name: 'Cobol'
			},
			{
			  id: 1,
			  name: 'JavaScript'
			},
			{
			  id: 2,
			  name: 'Basic'
			},
			{
			  id: 3,
			  name: 'PHP'
			},
			{
			  id: 4,
			  name: 'Java'
			}
		  ]

		return <div>
			<BackToGuard guardId={guardId} name={this.state.guardName} />
			<Card>
                <Row className="toolbar up-card-title">
                    <div className="b-title"><i className="ti-map-alt mr-10"></i>&nbsp;Guard Information</div>
                    {guardId!="null"?
						<a onClick={()=>{this.props.history.push('/duty/'+guardId)}}>
                        <div className="b-title-end">View Location Duties&nbsp;<i className="ti-align-left"></i></div>
                    </a>:<div></div>}
                </Row>
                <Row className="toolbar up-card-box justify-content-center">
					<div className="col-md-3" style={{textAlign:"center"}}>
						<img src = {avatarUrl!=""?avatarUrl=="/storage/avatar.jpg"?avatar:baseImgURL+avatarUrl:avatar} className="img-company"></img>
						<Form>
							<FormGroup>
								{/* <Input type="file" name="file" id="exampleFile" onChange={this.onDrop} /> */}
								<ImageUploader
									withIcon={false}
									buttonText='Choose images'
									onChange={this.onDrop}
									accept='image/jpeg,image/png'
									imgExtension={['.jpg', '.jpeg', '.png']}
									maxFileSize={204800}
									label='Max file size: 200KB, max dimensions: 360x360px, accepted: jpg, png'
									singleImage={true}
								/>
							</FormGroup>
						</Form>
					</div>
                    <form className="col-md-7" name="myForm" onSubmit={this.onSave}>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">First name</label>
							<div className="col-md-9">
								<input className="location-text-input" name="firstName" type="text" value={this.state.firstName} onChange={this.handleChange} required></input>
							</div>
						</Row>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">Last name</label>
							<div className="col-md-9">
								<input className="location-text-input" name="secondName" type="text" value={this.state.secondName} onChange={this.handleChange} required></input>
							</div>
						</Row>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">CID</label>
							<div className="col-md-9">
								<input className="location-text-input" name="CID" type="text" inputMode="numeric" maxLength={10} placeholder="4 to 10 digits" value={this.state.CID} onChange={this.handleChange} required></input>
							</div>
						</Row>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">Phone</label>
							<div className="col-md-9">
								<PhoneList
									dialCode={this.state.dialCode}
									phones={[this.state.phoneValue].concat(this.state.otherPhones)}
									editing={{ kind: 'guard', id: this.state.guardId }}
									onChange={(list) => this.setState({ phoneValue: list[0] || '', otherPhones: list.slice(1) })} />
							</div>
						</Row>
						{this.state.guardId != "null" ? (
						<Row className="company-text-area">
							<label className="col-md-3 control-label">On duty</label>
							<div className="col-md-9">
								<GuardDutySwitch guardId={this.state.guardId} onDuty={this.state.onDuty} />
							</div>
						</Row>
						) : null}
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">timezone</label>
							<div className="col-md-9">
								<TimeZoneField
							  country={this.state.selectedCountry || this.state.defaultCountry}
							  value={this.state.timeValue ? this.state.timeValue.value : null}
							  onChange={(zone) => this.setState({ timeValue: zone ? { value: zone, label: zone } : '' })}
							/>
							</div>
						</Row>
						<Row className="company-text-area">
							<label className="col-md-3 control-label">District</label>
							<div className="col-md-9">
								<Select name="district_id" options={districtLst} value = {districtOption}
								onChange={this.districtChange} isDisabled={isDistrictManager()} required/>
							</div>
						</Row>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">District Manager</label>
							<div className="col-md-9">
								<Select isDisabled={isDistrictManager()} options={managerLst} value={managerOption} onChange = {this.managerChange}></Select>
							</div>
						</Row>
					
						<div className="height-10"></div>
						<Row className="d-flex justify-content-center">
							<Button type = "submit" className = "saveButton">Save Change</Button>
						</Row>
						<div className="height-10"></div>
					</form>
                </Row>
            </Card>
			<Modal isOpen={this.state.showAlert} toggle={this.toggle}>
			{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>{this.state.alertMessage}</h2>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" style={{width:'100px'}} className="ml-1" onClick={this.toggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" style={{width:'100px'}} onClick={this.toggle}>Ok</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<SharedPhoneModal
				isOpen={this.state.sharedPhone != null}
				message={this.state.sharedPhone ? this.state.sharedPhone.message : ''}
				details={this.state.sharedPhone ? this.state.sharedPhone.details : []}
				person={this.state.sharedPhone ? this.state.sharedPhone.person : null}
				onYes={this.confirmSharedPhone}
				onNo={() => this.confirmSharedPhone(null)}
				onCancel={() => this.setState({ sharedPhone: null })} />
		</div>
	}
}

export default CompanyView;
